import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'c-item',
  templateUrl: './item.component.html',
  styleUrl: './item.component.css',
  // Sin esto, el navegador trata <c-item> (elemento desconocido) como
  // `display: inline` por defecto, lo que le impide al div interno
  // `w-full` ocupar el ancho real disponible del contenedor del sidebar.
  // Mismo bug ya encontrado antes en la sesión (c-instructivos-panel).
  host: { class: 'contents' },
  standalone: false,
})
export class ItemComponent {
  private readonly router = inject(Router);

  @Input() routerLink: string = '/capacitaciones';

  @Input() titulo: string = 'Inserte titulo';

  @Input() iconoActivo = 'svg/training-fill.svg';

  @Input() iconoInactivo = 'svg/training.svg';

  @Input() collapse = false;

  @Input() isForRoot = true;

  isActive: boolean = false;

  ngOnInit() {
    //Suscríbete a los cambios de la URL para verificar si la ruta está activa
    //TODO Defines the strategy for comparing the matrix parameters of two `UrlTree`s.
    this.router.events.subscribe(() => {
      this.isActive = this.router.isActive(this.routerLink, {
        matrixParams: 'ignored',
        queryParams: 'ignored',
        paths: 'subset',
        fragment: 'ignored',
      });
    });
  }
}
